import { BaseRouteService } from 'core/services';

class ShipmentInfoRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'shipment-infos/';
	}

	find = filter => {
		return super.create(this.base + 'search', filter);
	};

	exportToCsv(filter) {
		return super.create(this.base + 'export', filter);
	}

	get = (id, options) => {
		return super.get(this.base + '{id}/{?embed}', id, options);
	};

	create = sourceOfChange => {
		return super.create(this.base + '/?sourceOfChange={sourceOfChange}', sourceOfChange);
	};

	update = (resource, revertFulfillmentOrderStatus, sourceOfChange) => {
		return super.update(
			this.base + '{id}/?revertFulfillmentOrderStatus={revertFulfillmentOrderStatus}&sourceOfChange={sourceOfChange}',
			resource,
			{ revertFulfillmentOrderStatus, sourceOfChange }
		);
	};

	scanTrackingNumber = () => {
		return this.uriTemplateService.parse(`${this.base}scan-tracking-number`).expand();
	};

	removeFromPallet = requestContent => {
		return this.uriTemplateService
			.parse(`${this.base}remove-from-pallet/?id={id}&sourceOfChange={sourceOfChange}`)
			.expand(requestContent);
	};

	exportLabels = (carrierTypeId, serviceTypeId, dateTime) => {
		return super.get(this.base + 'exportToday/{id}/{serviceTypeId}/?dateTime={dateTime}', carrierTypeId, {
			serviceTypeId,
			dateTime,
		});
	};

	// Old labeling mode.
	getFulfillmentOrderShipment(upc, sourceOfChange) {
		return super.get(this.base + 'get-fulfillment-order-shipment/{id}/?sourceOfChange={sourceOfChange}', upc, {
			sourceOfChange,
		});
	}

	// New labeling mode.
	createOrGetShipment(createOrGetShipmentParams, sourceOfChange) {
		return super.update(
			this.base + 'create-or-get-shipment/?sourceOfChange={sourceOfChange}',
			createOrGetShipmentParams,
			{ sourceOfChange }
		);
	}

	updateShipmentInfoByTrackingNumber = (resource, sourceOfChange) => {
		return super.update(this.base + 'scan/{trackingNumber}/?sourceOfChange={sourceOfChange}', resource, {
			sourceOfChange,
		});
	};

	undoPalletize = (scanParams, sourceOfChange) => {
		return super.update(this.base + 'scan-undo/?sourceOfChange={sourceOfChange}', scanParams, { sourceOfChange });
	};

	reprintLabel = (shipmentInfoId, getLabel) => {
		return super.update(this.base + 'reprintLabel/{shipmentInfoId}/{?getLabel}', { shipmentInfoId, getLabel });
	};

	bulkPrint = (bulkPrintFulfillmentOrders, sourceOfChange) => {
		return super.create(this.base + 'bulk-print/?sourceOfChange={sourceOfChange}', bulkPrintFulfillmentOrders, {
			sourceOfChange,
		});
	};

	delete = resource => {
		return super.delete(this.base + '{id}', resource);
	};

	voidLabel(voidOption, sourceOfChange) {
		return super.get(this.base + 'plain-void/?voidOption={voidOption}&sourceOfChange={sourceOfChange}', null, {
			voidOption,
			sourceOfChange,
		});
	}

	undoLabelCreated = undoLabelCreatedParams => {
		return super.update(this.base + 'undo-label-created', undoLabelCreatedParams);
	};

	createReturnLabel = returnLabelParams => {
		return super.update(this.base + 'return-label', returnLabelParams);
	};
}
export default ShipmentInfoRouteService;
